/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ChatManagementEditIsReadedResponse } from './ChatManagementEditIsReadedResponse';

export type ChatManagementEditIsReadedResponseApiRespoonse = {
    data?: ChatManagementEditIsReadedResponse;
    status?: ChatManagementEditIsReadedResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace ChatManagementEditIsReadedResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

